import { pb } from './pb';

// Récupère le (seul) enregistrement de paramètres, ou null s'il n'existe pas encore
export async function fetchSettings(){
  const list = await pb.collection('settings').getList(1, 1, { sort: '-created' });
  return list.items?.[0] || null;
}

// Création de l'enregistrement de paramètres
export async function createSettings(data){
  return pb.collection('settings').create(data);
}

// Mise à jour des paramètres existants
export async function updateSettings(id, data){
  return pb.collection('settings').update(id, data);
}

// Helper pratique : sauvegarder (create ou update) en fonction de la présence d'un record existant
export async function saveSettings(existing, data){
  if(existing && existing.id){
    return updateSettings(existing.id, data);
  }
  return createSettings(data);
}
